<template>
  <div class="clouddisk">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="javascript:void(0);">我的云盘</a></li>
          <li class="">
            <router-link to="/home/geturl">下载链接导出</router-link>
          </li>
          <li class="fr" v-if="type === 2">
            <router-link to="/home/cloudDisk">全部文件夹</router-link>
          </li>
          <li class="fr" v-else>
            <router-link to="/home/cloudDisk">全部文件夹</router-link> > <a
              href="javascript:void(0)">{{type === 0 ? '遥感数据' : '遥感产品'}}</a>
          </li>
        </ul>
      </nav>
    </div>
    <el-table :data="tableData" stripe style="width: 100%" class="messagelist" v-loading="loading">
      <el-table-column label="文件名" width="340">
        <template slot-scope="scope">
          <!-- <i class="el-icon-folder"></i><a href="javascript:void(0);" @click="gotoItem(scope.row)">{{ scope.row.name }}</a> -->
          <i class="el-icon-folder"></i><a v-if="type === 2" href="javascript:void(0);"
            @click="myCloudFiles(scope.row.type)">{{ scope.row.type === 0 ? '遥感数据' : '遥感产品' }}</a>
          <a v-else href="javascript:void(0);" @click="myOrderFiles(scope.row)">{{ scope.row.orderCode }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="fileSize" label="大小" align="center" width="180">
      </el-table-column>
      <el-table-column prop="fileModifyDate" label="时间" align="center" width="180">
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="looktd">
        <template slot-scope="scope">
          <a v-if="type === 2" href="javascript:void(0);" @click="myCloudFiles(scope.row.type)" class="lookfor">查看</a>
          <a v-else href="javascript:void(0);" @click="myOrderFiles(scope.row)" class="lookfor">查看</a>
          <!-- <a href="javascript:void(0);" @click="gotoItem(scope.row)" class="lookfor">查看</a> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total>pageSize">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" background
        layout="sizes, prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'cloudDisk',
  components: {
  },
  created () {
    if (this.$route.params.status) {
      this.$emit('topMenuStatus', this.$route.params.status)
    }
    // this.cloudFiles()
    if (this.$route.params.type !== undefined) {
      this.type = this.$route.params.type
    }
    this.myCloudFiles(this.type)
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 5,
      type: 2,
      tableData: [],
      loading: true
    }
  },
  methods: {
    myCloudFiles (type) {
      this.type = type
      let queryParams = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        type: type
      }
      this.sapost('/dmc/account/myCloudDisk', queryParams, r => {
        this.loading = false
        let { retMsg, retCode, pager } = r.data
        if (retCode === '0') {
          this.total = pager.total
          this.pageSize = pager.pageSize
          this.tableData = pager.list
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    myOrderFiles (val) {
      this.$router.push({ name: 'cloudDiskOne', params: { orderCode: val.orderCode, type: val.type } })
    },
    cloudFiles () {
      let queryParams = {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      this.sapost('/dmc/account/virtualDisk', queryParams, r => {
        let { retMsg, retCode, pager } = r.data
        if (retCode === '0') {
          this.total = pager.total
          this.pageSize = pager.pageSize
          this.tableData = pager.list
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      // this.cloudFiles()
      this.myCloudFiles(this.type)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      // this.cloudFiles()
      this.myCloudFiles(this.type)
    },
    gotoItem (p) {
      this.$router.push({ name: 'cloudDiskOne', params: { path: p.path, name: p.name } })
    }
  }
}
</script>

<style lang="less">
.clouddisk {
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  .t-nav {
    nav {
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 15px;
        height: 60px;
        color: #b4b8bb;
        li {
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a {
            color: #b4b8bb;
          }
        }
        li.active,
        li:hover {
          border-bottom: 2px solid #f01400;
          a {
            color: #f01400;
          }
        }
        li.fr {
          float: right;
          margin-right: 50px;
          a {
            color: #333;
            font-size: 12px;
          }
          .router-link-exact-active {
            border-bottom: 0px;
          }
        }
      }
    }
  }
  .r-title {
    float: right;
    height: 60px;
    line-height: 60px;
    span {
      color: #f01400;
    }
  }
  .pages {
    text-align: right;
    padding-top: 15px;
  }
  .messagelist {
    .el-table__body tr:hover > td {
      background-color: #fef3f3;
    }
    tr:hover {
      td {
        border-bottom: 1px solid #fef3f3;
      }
      .lookfor {
        background-color: #f20d0c;
        color: #fff;
        padding: 3px 29px;
        border-radius: 29px;
        display: inline-block;
      }
      td.looktd {
        padding: 6px 0;
      }
    }
    .cell {
      color: #333;
      i {
        font-size: 24px;
        margin-right: 5px;
        color: #ffb805;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/clouddisk.vue